import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../lib/api";

export default function AuthCallback() {
  const nav = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) {
      nav("/");
      return;
    }
    auth
      .session(sessionId)
      .then(() => {
        window.history.replaceState({}, "", "/app");
        nav("/app", { replace: true });
      })
      .catch(() => {
        nav("/");
      });
  }, [nav]);

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center">
      <div className="text-center">
        <div className="mx-auto w-12 h-12 rounded-full border-2 border-fuchsia-500 border-t-transparent animate-spin mb-4" />
        <div className="font-mono text-xs tracking-widest text-zinc-400">CONNECTING...</div>
      </div>
    </div>
  );
}
